import React, { useRef, useState } from "react";
import styles from "./AddEvent.module.css";

import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import CalendarInput from "../../components/CalendarInput/CalendarInput";

import { FaRegFileAlt } from "react-icons/fa";
import { FiUpload } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import { LuUpload } from "react-icons/lu";
import Attachment from "../../components/Attachment/Attachment";


const AddEvent = () => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    title: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    type: "",
    staff: "",
    rooms: "",
    staffOnly: false,
    description: "",
    image: null,
    imageUrl: "",
    notifyStaff: false,
    notifyParent: false,
    disableComments: false,
    file: null,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleDateChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setFormData((prev) => ({ ...prev, image: file, imageUrl }));
    }
  };

  const triggerImageUpload = () => {
    fileInputRef.current?.click();
  };

  const handleFileUpload = (e) => {
    setFormData((prev) => ({ ...prev, file: e.target.files[0] }));
  };

  const handleSave = () => {
    console.log("Event Form Data:", formData);
    if (!formData.file) {
      console.warn("No file selected!");
    }
    // Proceed with save...
  };
  

  const handleCancel = () => {
    setFormData({
      title: "",
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
      type: "",
      staff: "",
      rooms: "",
      staffOnly: false,
      description: "",
      image: null,
      imageUrl: "",
      notifyStaff: false,
      notifyParent: false,
      disableComments: false,
      file: null,
    });
   
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<FaRegFileAlt />} heading="Add event" />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>
      <div className={styles.content}>
        <div className={styles.section}>
          <HeadingAndIcon icon={<FaRegFileAlt />} heading="Event details" />
        </div>
        <div className={styles.data}>
          <div className={styles.coverPhotoBox}>
            {formData.imageUrl ? (
              <img
                src={formData.imageUrl}
                alt="Cover"
                className={styles.coverImage}
              />
            ) : (
              <span className={styles.coverLabel} onClick={triggerImageUpload}>
                Add cover Photo
              </span>
            )}
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleImageUpload}
              style={{ display: "none" }}
            />
          </div>

          <div className={styles.formGrid}>
            <HeadingAndData
              label="Title"
              name="title"
              placeholder="Enter shift name"
              value={formData.title}
              onChange={handleChange}
              required
            />
            <CalendarInput
              fieldLabel="Start date"
              value={formData.startDate}
              onChange={(val) => handleDateChange("startDate", val)}
              required
            />
            <CalendarInput
              fieldLabel="End date"
              value={formData.endDate}
              onChange={(val) => handleDateChange("endDate", val)}
              required
            />
            <HeadingAndData
              label="Start Time"
              name="startTime"
              type="time"
              value={formData.startTime}
              onChange={handleChange}
              required
            />
            <HeadingAndData
              label="End Time"
              name="endTime"
              type="time"
              value={formData.endTime}
              onChange={handleChange}
              required
            />
            <HeadingAndDropDown
              label="Type"
              name="type"
              value={formData.type}
              onChange={handleChange}
              options={[
                { label: "Seminar", value: "seminar" },
                { label: "Cultural", value: "cultural" },
              ]}
              required
            />
            <HeadingAndDropDown
              label="Assign Staff"
              name="staff"
              value={formData.staff}
              onChange={handleChange}
              options={[
                { label: "John", value: "john" },
                { label: "Jane", value: "jane" },
              ]}
              required
            />
            <HeadingAndDropDown
              label="Rooms"
              name="rooms"
              value={formData.rooms}
              onChange={handleChange}
              options={[
                { label: "Room A", value: "roomA" },
                { label: "Room B", value: "roomB" },
              ]}
              required
            />
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                name="staffOnly"
                checked={formData.staffOnly}
                onChange={handleChange}
              />
              Staff Only
            </label>
          </div>

          <div className={styles.textareaWrapper}>
            <label>Event description</label>
            <textarea
              className={styles.textarea}
              placeholder="Describe your thoughts"
              name="description"
              value={formData.description}
              onChange={handleChange}
            ></textarea>
          </div>
          <div className={styles.bottomsection}>
            <div className={styles.checkSection}>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  name="notifyStaff"
                  checked={formData.notifyStaff}
                  onChange={handleChange}
                />
                Send Notification to staff
              </label>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  name="notifyParent"
                  checked={formData.notifyParent}
                  onChange={handleChange}
                />
                Send Notification to parent
              </label>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  name="disableComments"
                  checked={formData.disableComments}
                  onChange={handleChange}
                />
                Disable comments
              </label>
            </div>
            <div className={styles.uploadBlock}>
              <Attachment
                label="Attach any file"
                accept="video/*"
                required={true}
                onFileSelect={(file) => {
                  console.log("Uploading file in AddEvent:", file); // ✅ DEBUG
                  setFormData((prev) => ({ ...prev, file }));
                }}
              />
            </div>
          </div>

          <div className={styles.actions}>
            <SaveAndCancel onCancel={handleCancel} onSave={handleSave} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEvent;
